import { OBJECT_TYPES } from "appConstants";

export const SETTINGS = [
  {
    apiName: "processNumber",
    component: "FrmTransactionNumber",
    transactionType: OBJECT_TYPES.PROCESS.fullString,
    hasInputLabel: true,
  },
];
